export default function SupportHelp() {
    return (
        <section className="py-[40px]">
            <div className="container flex justify-between items-center">
                <div className="w-[48%]">
                    <div className="text-[40px] text-[#2563eb]">Knowledgeable support to help you before and after you file</div>
                    <p>
                        We offer live support via phone, email and chat. Our team has earned a top-notch reputation for helping people since 2014. Over 94% of our customers give us 5 stars
                    </p>
                </div>
                <div className="w-[48%]">
                    <img className="w-[65%] h-full rounded-full" src={require("../../assets/images/help.jpg")} alt="" />
                </div>

            </div>
        </section>
    );
}